import { scheduleServiceWebServiceLog } from '../../js/components/XTimeScheduleServicePage/Services/ScheduleService';
import { SCHEDULE_SERVICE_DEALER_TRACK_BOOK_APPOINTMENT_TYPEID } from '../../js/components/XTimeScheduleServicePage/Services/scheduleServiceConstants';
import * as actionTypes from '../types';
import axios from 'axios';
export const ScheduleServicePage = {
  state: {
    timeSlotSpecificScheduleServiceSettings: [],
    specificTimeSlotSettingsByDate: '',
    timeList: [],
    selectedTime: '',
    timeValidationErr: true,
    selectedDealerTrackServices: [],
    selectedServiceWriter: '',
    serviceWriterErrorMessage: '',
    dealerTrackSubmitResponse: '',
    scheduleServiceRequest: '',
    initiateFormFired: false,
    initiateFormEventsFired: false,
  },
  mutations: {
    [actionTypes.SCHEDULE_SERVICE_GENERIC_REQUEST](state, payload) {
      state.scheduleServiceRequest = payload;
    },
    [actionTypes.SCHEDULE_SERVICE_DEALER_TRACK_RESPONSE](state, payload) {
      state.dealerTrackSubmitResponse = payload;
    },
    [actionTypes.SCHEDULE_SERVICE_VALIDATION_ERROR_MSG](state, payload) {
      state.serviceWriterErrorMessage = payload;
    },
    [actionTypes.SCHEDULE_SERVICE_SELECTED_SERVICE_WRITER](state, payload) {
      state.selectedServiceWriter = payload;
    },
    [actionTypes.SCHEDULE_SERVICE_SELECTED_DEALER_TRACK_SERVICES](state, payload) {
      state.selectedDealerTrackServices = payload;
    },
    [actionTypes.SET_SCHEDULE_SERVICE_TIME_SLOT_BY_SPECIFIC_DATE](state, payload) {
      state.specificTimeSlotSettingsByDate = payload;
    },
    [actionTypes.SET_SCHEDULE_SERVICE_TIME_LIST](state, payload) {
      state.timeList = payload;
    },
    [actionTypes.SET_SCHEDULE_SERVICE_SELECTED_TIME](state, payload) {
      state.selectedTime = payload;
    },
    [actionTypes.SELECT_SCHEDULE_SERVICE_TIME_ERROR](state, payload) {
      state.timeValidationErr = payload;
    },
  },
  getters: {
    [actionTypes.SCHEDULE_DEALER_TRACK_SERVICE_STRING](state) {
      let serviceList = [];
      state.selectedDealerTrackServices.map((item) => {
        serviceList.push(item.description);
      });
      return serviceList.toString();
    },
    [actionTypes.SET_SDA_INITIATE_FORM_FIRE](state, payload) {
      state.initiateFormFired = payload;
    },
    [actionTypes.SET_SDA_INITIATION_FORM_EVENT_FIRE](state, payload) {
      state.initiateFormEventsFired = payload;
    },
  },
  actions: {
    [actionTypes.SET_SCHEDULE_SERVICE_TIME_SLOT_SETTINGS](context) {
      let url = `${window.ApiBaseUrl}/ServiceScheduler/TimeSlotSpecificScheduleServiceSettings?campaignID=${window.campaignId}`;
      axios.get(url).then((response) => {
        context.state.timeSlotSpecificScheduleServiceSettings = response.data;
      });
    },
    async [actionTypes.SUBMIT_SCHEDULE_SERVICE_DEALER_TRACK](context) {
      let payload = context.state.scheduleServiceRequest;

      let scheduleTime = new Date(payload.dateTime);
      let day = ('0' + scheduleTime.getDate()).slice(-2);
      let month = ('0' + (scheduleTime.getMonth() + 1)).slice(-2);
      let minutes = ('0' + scheduleTime.getMinutes()).slice(-2);
      let hours = ('0' + scheduleTime.getHours()).slice(-2);

      let formatDate = `${scheduleTime.getFullYear()}${month}${day}${hours}${minutes}`;
      let services = context.state.selectedDealerTrackServices.map((item) => {
        return {
          comments: item.description,
          serviceType: item.serviceTypeCode,
        };
      });
      let request = {
        campaignId: window.campaignId,
        accountId: window.accountId,
        applicationId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
        sessionId: window.tid.toUpperCase(),
        vin: payload?.vin || '',
        modelYear: payload.year,
        make: payload.make,
        model: payload.model,
        odometerIn: payload.vehicleMileage,
        firstName: payload.firstName,
        lastName: payload.lastName,
        emailAddress: payload.primaryEmailID,
        phoneNumber: payload.primaryPhoneNumber,
        apptDateAndTime: formatDate,
        serviceWriterID: context.state.selectedServiceWriter,
        services: services,
      };
      let webServiceRequest = {
        request: request,
        response: '',
        status: '',
        typeId: SCHEDULE_SERVICE_DEALER_TRACK_BOOK_APPOINTMENT_TYPEID,
      };
      let url = `${window.schedulerDealerTrackApiURL}/api/Scheduler/BookAppointment`;
      await axios
        .post(url, request)
        .then((response) => {
          webServiceRequest.status = response.data.status;
          webServiceRequest.response = response;
          context.commit(actionTypes.SCHEDULE_SERVICE_DEALER_TRACK_RESPONSE, response);
          scheduleServiceWebServiceLog(webServiceRequest);
        })
        .catch((error) => {
          webServiceRequest.status = error;
          context.commit(actionTypes.SCHEDULE_SERVICE_DEALER_TRACK_RESPONSE, error);
          webServiceRequest.response = error;
          scheduleServiceWebServiceLog(webServiceRequest);
        });
    },
  },
};
